import { useSyncExternalStore } from 'react';

/**
 * Visual novo "estilo Google" (spec 017) — da pessoa (segue a conta,
 * `prefsNaConta`, desde 26/10/2026; antes era por máquina) e DESLIGADO por padrão:
 * Configurações › Tela de Atendimento › "Visual novo (estilo Google)" grava
 * `dratento.visual.google = 1`. Ligado, o <html> ganha `data-visual="google"`
 * e `src/styles/visual-google.css` troca paleta, fonte e cantos; a ficha ganha
 * o campo de ditado e a barra com nomes. Desligado, tudo fica como era.
 */
export const VISUAL_GOOGLE_KEY = 'dratento.visual.google';

const CHANGE_EVENT = 'dratento:visual';

const readEnabled = () => {
  try {
    return localStorage.getItem(VISUAL_GOOGLE_KEY) === '1';
  } catch {
    return false;
  }
};

/** Portal do paciente (/portal, /portal/login, /portal/painel…): o visual
 *  Google vale SEMPRE, independente da chave — decisão de 14/10/2026. A chave
 *  é da equipe e mora nas Configurações dela, que o paciente nunca
 *  abre; sem isto, ele nunca veria o visual novo no celular dele. */
export const isPortalPath = (pathname: string) => /^\/portal(\/|$)/.test(pathname);

/** Põe/tira o atributo no <html> — o CSS do visual novo é todo escopado nele. */
export const applyVisualGoogle = (
  on = readEnabled() || (typeof window !== 'undefined' && isPortalPath(window.location.pathname)),
) => {
  if (on) document.documentElement.setAttribute('data-visual', 'google');
  else document.documentElement.removeAttribute('data-visual');
};

const subscribeEnabled = (cb: () => void) => {
  window.addEventListener(CHANGE_EVENT, cb);
  window.addEventListener('storage', cb);
  return () => {
    window.removeEventListener(CHANGE_EVENT, cb);
    window.removeEventListener('storage', cb);
  };
};

/** Liga/desliga ao vivo: quem usa o hook atualiza na hora, sem recarregar. */
export const useVisualGoogle = (): boolean =>
  useSyncExternalStore(subscribeEnabled, readEnabled, () => false);

export const setVisualGoogle = (on: boolean) => {
  try {
    localStorage.setItem(VISUAL_GOOGLE_KEY, on ? '1' : '0');
  } catch {
    /* sem storage: fica como está */
  }
  applyVisualGoogle(on);
  window.dispatchEvent(new Event(CHANGE_EVENT));
};

// Outra aba ligou/desligou: o atributo acompanha.
if (typeof window !== 'undefined') {
  window.addEventListener('storage', (e) => {
    if (e.key === VISUAL_GOOGLE_KEY) applyVisualGoogle();
  });
}
